// ------- background
import HydrationBg from "./images/hydration_bg.jpg";
import LeanBg from "./images/get_lean_bg.jpg";
import BuildMuscleBg from "./images/build_muscle_bg.jpg";
import RecoverBg from "./images/recover_bg.jpg";
import WheyBg from "./images/whey.jpg";
import PwBg from "./images/pw_bg.jpg";
import PlantBasedBg from "./images/plant_based_bg.jpg";
export const backgroundMapping = {
    hydration_mango: HydrationBg,
    boost_get_lean: LeanBg,
    boost_build_muscle: BuildMuscleBg,
    boost_recover: RecoverBg,
    protein_whey: WheyBg,
    preworkout_strawberry: PwBg,
    protein_plant: PlantBasedBg,
};
